<template>
  <v-col>
    <DisplayCalculationStateComponent
      v-if="recalculationLoading"
      class="mx-2"
    />
    <v-skeleton-loader
      type="image"
      class="my-2 mx-2"
    />
    <v-skeleton-loader
      type="image"
      class="my-2 mx-2"
    />
    <v-skeleton-loader
      type="image"
      class="my-2 mx-2"
    />
  </v-col>
</template>

<script>
import { mapState } from "vuex";
import DisplayCalculationStateComponent from "./components/recompute_voyage/DisplayCalculationState.vue";
export default {
  name: "VoyageDetailsLoadingComponent",
  components: {
    DisplayCalculationStateComponent,
  },
  computed: {
    ...mapState("weatherRouting/voyageDetailsModule", ["recalculationLoading"]),
  },
};
</script>
